module.exports = __webpack_public_path__ + "static/media/hair (30).cc084061.jpg";